const create_UUID = () => {
  var dt = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
};
const defaultGAData = {
  v: 1,
  t: "event",
  tid: "UA-155375238-1",
  // tid: "UA-44521541-14"
};
const getGACookieClientId = () => {
  if (document.cookie) {
    var cookie = document.cookie;
    // var cookie =
    //   "_ga=GA1.2.1376524038.1586399232; _gid=GA1.2.474021163.1589808265; front10-mission-control-key=claire.19.4.2020; fr-mission-control-user-info=38770c2eb6435b5c655b79e14feee1934f4dd5fab0c6ca9334d35948ac648175s+vTBw4/uFMsEg9LLrzKAK009/jGrPzhSUiHPmGyHXXZ0Yd9j3rjd2vYKIdjZvv6WPO3lecYzq47sXF+ska3eG4vH7irdrlaJEpPUbiets44hKfnVEk2ccgWuoJU9E2Oir7Evh8rRVlOeYd30e1lDBdNqZxfyHxNo6peD9DoAgJxuGuizsqCOhRqpGOdDs2HXfWGfCcBRpHTr8shIby/gvDjgE8tb9URsFOlzdakPSW1Sf2JnW9sT+7PytFAom62ONwxv+Lr7WbeGAhRkmQSzvwFfPRlPCj9o+L7udM/VosdFEho4neKhCJvI58eMoNhtHqVZeef6Pr+lA+VTP4V1IfxXvUStarKvlkChKEyHqzrlGtogv91GAUIkKa1p1OjAYv3Tb+nyn/OOa/27iWdLbcssxZkf18qeWBfhswRUC83AywQB0V50VhTmJJL4WIzIlZ3w4huOjlcp7mvTq2Wh0ssXtSOXfqZIx9jP5/Y6uVLg222QfZXaHqqckXG5TYU7WGSYBXpJmYEpjxe4TyqYgsgRSEWKj6QgHwJuzkLaFiGopVBO0gYvObeVLRwf1MNeC3VqVTwplxKbQ8xnekuBq9bEA5+9uCHh5o6FHWxYOt7hK4jn6TqZQijTwLplUB4syG7vQiiqZmYkb+5Jt+wnIK0ZJ8W1DLLZkMk9UPcmjrt8UDsXQqVwS1QhpWk6JBOkQKarXKBSb+PrmgzKKnnnZPjc7HvqZ8RBq9O5QsoM7R7bNSXkgaL6symYfwHKbMZPPsArxydIDVrMTToYkj8pbFI7Z5iH+ynOCZjfv6U/wvCfa4JaBB7M6OC9nlHCbm07nPBE6JI8v5xpnoqa5E/UUMlwFHUjeIDbMGxXme2bqyzr/61ZCXZcwCq1wqYZ28QjbpyjuAeAyXcnE20hj1f5cbf8J18EpEtwhnEXPgqMpKaruPU8jBxVsuYYRYs+mzBW3Gc956/TNqdVyVDqYQKVuHaBtNOwbqLT6lZd9mQ/lb7VHajlbi468GQkzjTx3X4wnrNRICzI1hUdvrtU3pZ8USD/UbU7yvZLQNcDj6JiBgpaOP+J6LXufVwjMiC/jODXUrfWLfyuKJHuJo3U7T+JOvfrL0MpU16y2TE917S2xPbPVza5kH7M3v696FV5Dt5/Vh8eskaXH8tX/uMetlieEdaXxpR/ryjUwjMlNgsugsjsac4NeiAGJ1P/dimEkklDSyPfd2hmR3LqQ+SKauPQaFwNADr2zVQJ4JuEo9ew+v+4OQZitbMRb/nYd3Y2MadeMQqIF0x7gy/BRZkTLSqwcZmr9Vy422ZUAZw2VscIrK01uRJ7+uja7apaKT4UggB1lA8Wd79KTrfbYftFn3cKS9MEpIJL6MdPT1cou4EwZI82IVi26FUz5TLDqdUSaKB0eaeLJ9xftHrbH01idnqDetFiGSIsuHSwhxVAxPp27630bL01lTAL/Af39qxlrwZwKbN65YkyyyTAj38X5N0Qg88qUaZIdUsemItLyXQ29CV14ylmod1YAzszkesodjsmZd353NY0OneBzHnC8Jp7G0XhtHaOO05CnRiz3BYCeXBIL9XLkpHUV2H7N1DvLBi/3gIPDu1kA9xVOYHRuOv71as0wwjp0pXgh3v5ZZVL7dIGpD6tJ/k2owY0ne8gLdsA4O8Wnu6ZuGYzXPFn4sE6yXrnn1mhgxPeBDU4yC9sKuIQZZZWk5qTwIXIXKtFEMu; fr-mission-control-user-config=a4d6c5cac6f580c9d2a0ec825d00b59e970b83d144af21bab7a7573ac52c29afwB+MUSFN5vnVm237kBobumHRQC7jyaCb+QkS4tUBW85rvTqYhIWgG4kOJmvyOq+foiU9MiLIz5SicLNT/ufvuA==";
    var clientId = cookie.match(/_ga=(.+?);/)
      ? cookie
          .match(/_ga=(.+?);/)[1]
          .split(".")
          .slice(-2)
          .join(".")
      : cookie.match(/_ga=(.+?)$/)
      ? cookie
          .match(/_ga=(.+?)$/)[1]
          .split(".")
          .slice(-2)
          .join(".")
      : false;
    return clientId;
  }
  return false;
};
const getOwnCookieClientId = () => {
  var clientId = document.cookie.match(/_mc_uid=(.+?);/)
    ? document.cookie.match(/_mc_uid=(.+?);/)[1]
    : document.cookie.match(/_mc_uid=(.+?)$/)
    ? document.cookie.match(/_mc_uid=(.+?)$/)[1]
    : false;
  if (!clientId) {
    clientId = create_UUID();
    document.cookie = `_mc_uid=${clientId}`;
  }
  return clientId;
};
const getClientId = () =>
  retrieveClientID()
    ? retrieveClientID()
    : getGACookieClientId()
    ? getGACookieClientId()
    : getOwnCookieClientId();

const encodeToUrlForm = (params) => {
  var query = "";
  for (const key in params) {
    if (params[key])
      query +=
        encodeURIComponent(key) + "=" + encodeURIComponent(params[key]) + "&";
  }
  return query;
};
const sendGAMeasureProtocol = (pageContext, defaultData = defaultGAData) => {
  return new Promise((resolve, reject) => {
    var data = encodeToUrlForm(
      Object.assign(defaultData, { cid: getClientId() }, pageContext)
    );
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        try {
          resolve(JSON.parse(this.responseText));
        } catch (error) {
          resolve({});
        }
      }
    });
    var endPoint = "https://www.google-analytics.com/collect";
    xhr.open("POST", endPoint);
    // xhr.setRequestHeader(
    //   "content-type",
    //   "application/x-www-form-urlencoded; charset=UTF-8"
    // );
    xhr.send(data);
  });
};

// Normalize component name
const convertCmpName = (emName) => {
  const res = emName.replace(/([a-z0-9])([A-Z])/g, "$1 $2").toLowerCase();
  let result = res.replace(/ /g, "-");
  if (result === "fare-list-two-column") result = "fare-list--two-columns";
  return result;
};

const retrieveId = () => window.MC.USrc.Parent.cpmId;

// Sen tracking to parent window
const sendTrackingToParent = (event, data, provider) => {
  if (window.parent) {
    const id = retrieveId();
    window.parent.postMessage(
      {
        event: "tracking.mc",
        payload: {
          event,
          provider,
          id,
          data: JSON.parse(JSON.stringify(data)),
        },
      },
      "*"
    );
  }
};
const emMapping = (name) => {
  const map = {
    "em.fare.popup.fareListTwoColumn": "fare-list--two-columns",
    "em.fare.popup.fareListPopularDestination": "popular-destinations",
    "em.fare.popup.faresCarouselBackgroundImage":
      "fares-carousel-background-image",
    "em.fare.popup.fareListLowFareCalendar": "low-fare-calendar",
    "em.fare.popup.fareListFeaturedDestination": "featured-destination",
    "em.fare.popup.heroMonthlyHistogramContainer": "hero-monthly-histogram",
    "em.fare.popup.fareTable": "fare-table",
    "em.fare.popup.faresGridBackgroundImage": "fares-grid-background-image",
  };
  return map[name] ? map[name] : name;
};
const retrieveCmpId = (name) => {
  var cmpid = emMapping(name);
  if (cmpid === name)
    if (window.MC && window.MC.Pages && window.MC.Pages.LoadedComponents) {
      var components = window.MC.Pages.LoadedComponents;
      for (let index = 0; index < components.length; index++) {
        const element = components[index];
        if (element.name === name) {
          cmpid = element.cmpId;
        }
      }
    }

  return cmpid;
};
// Old tracker listener for EM fare components
const oldEMTracking = (e) => {
  let name = e.split(".");
  name = name[3] || null;
  if (name) {
    name = convertCmpName(name);
    const data = {
      team: retrieveTeam(),
      userID: getClientId(),
      itemID: retrieveCmpId(e),
      availableComponents:
        retrieveAvailableComponents().length > 0
          ? retrieveAvailableComponents()
          : [{ name }],
      metric: "cta",
      conversion: true,
      componentTrack: retrieveCmpId(e),
      installedAt: retrieveInstalledAt(),
      pageContext: {
        code: retrieveCode(),
        url: window.IFrameReferer
          ? window.IFrameReferer
          : document.referrer
          ? document.referrer
          : window.location.href,
        referrer: document.referrer,
        urlTarget: window.location.href,
      },
    };
    window.MC.Helpers.collect(data);
  }
};

// New tracker listener for MC components
const missionControlTracking = (e, cmp) => {
  if (cmp && cmp.component && cmp.action) {
    let data = {
      availableComponents:
        retrieveAvailableComponents().length > 0
          ? retrieveAvailableComponents()
          : [
              {
                name: cmp.component,
                moduleId: cmp.moduleId,
                cmpId: cmp.cmpId,
                version: cmp.version,
                social: cmp.social,
              },
            ],
      team: retrieveTeam(),
      userID: getClientId(),
      itemID: cmp.component,
      metric: cmp.action,
      conversion: true,
      componentTrack: cmp.component,
      installedAt: retrieveInstalledAt(),
      social: cmp.social,
      pageContext: {
        code: retrieveCode(),
        url: window.IFrameReferer
          ? window.IFrameReferer
          : document.referrer
          ? document.referrer
          : window.location.href,
        referrer: document.referrer,
        urlTarget: window.location.href,
      },
    };
    if (cmp.action === "impression") {
      data.metric = "print";
      data.conversion = false;
      if (
        canISendThisWidgetImpression() &&
        data.pageContext.url !== "about:blank" &&
        data.pageContext.urlTarget !== "about:blank"
      ) {
        const sampling = retrieveSampling();
        if (sampling) data["sampling"] = sampling;
        window.MC.Helpers.collect(data);
      }
    } else window.MC.Helpers.collect(data);
  }
};

const GATracking = (e, cmp) => {
  if (cmp && cmp.component && cmp.action) {
    let data = {
      // an: cmp.component,
      // av: cmp.version,
      // aid: cmp.cmpId,
      // aiid: 'woxo',
      ec: "widget",
      ea: "click",
      dl: window.location.href,
      el: cmp.component,
      dr: window.IFrameReferer
        ? window.IFrameReferer
        : document.referrer
        ? document.referrer
        : window.location.href,
    };

    if (cmp.gclid && cmp.gclid !== "") {
      data["gclid"] = cmp.gclid;
    }
    if (cmp.action === "impression") {
      data.ea = "view";
      // data.el = "view";
      if (
        canISendThisWidgetImpression() &&
        data.dr !== "about:blank" &&
        data.dl !== "about:blank"
      ) {
        sendGAMeasureProtocol(data);
        if (retrieveInstalledAt() === 0) {
          data.ea = "install";
          sendGAMeasureProtocol(data);
        }
      }
    } else {
      sendGAMeasureProtocol(data);
    }
  }
};

const canISendThisWidgetImpression = () => {
  const sampling = retrieveSampling();

  if (!sampling) return 1;
  if (sampling && Math.random() > sampling) {
    return 1;
  }
  return 0;
};

const retrieveTeam = () =>
  (window.MC &&
    window.MC.Pages &&
    window.MC.Pages.Team &&
    window.MC.Pages.Team._id) ||
  "n-a";

const retrieveSampling = () =>
  (window.MC &&
    window.MC.Pages &&
    window.MC.Pages.Sampling &&
    window.MC.Pages.Sampling.value) ||
  0;
const retrieveClientID = () =>
  (window.MC &&
    window.MC.Pages &&
    window.MC.Pages.Tracking &&
    window.MC.Pages.Tracking.userId) ||
  0;
const retrieveCode = () =>
  (window.MC &&
    window.MC.Pages &&
    window.MC.Pages.Properties &&
    window.MC.Pages.Properties.code) ||
  0;
const retrieveInstalledAt = () =>
  (window.MC &&
    window.MC.Pages &&
    window.MC.Pages.Properties &&
    window.MC.Pages.Properties.installedAt) ||
  0;

const retrieveAvailableComponents = () => {
  if (window.MC && window.MC.Pages && window.MC.Pages.LoadedComponents) {
    var components = window.MC.Pages.LoadedComponents;

    var cmpData = [];
    components.forEach((element) => {
      const { name, cmpId, moduleId, version, gclid, social } = element;
      cmpData.push({ name, cmpId, moduleId, version, gclid, social });
    });

    return cmpData;
  }
  return [];
};

const listenTracking = (collect) => {
  if (
    collect &&
    (!window.MC || !window.MC.Helpers || !window.MC.Helpers.collect)
  ) {
    window.MC = window.MC || {};
    window.MC.Helpers = window.MC.Helpers || {};
    window.MC.Helpers.collect = collect;
  }
  // Old tracking for EM components
  if (
    window.EM &&
    window.EM.utils &&
    window.EM.utils.PubSub &&
    typeof window.EM.utils.PubSub.subscribe === "function"
  ) {
    window.EM.utils.PubSub.subscribe("em", oldEMTracking);
    window.EM.utils.PubSub.subscribe("em", (e, data) =>
      sendTrackingToParent(e, data, "em")
    );
  }

  // Tracking for mission control components
  if (
    window.MC &&
    window.MC.Vendors &&
    window.MC.Vendors.PubSub &&
    typeof window.MC.Vendors.PubSub.subscribe === "function"
  ) {
    window.MC.Vendors.PubSub.subscribe("tracking.mc", missionControlTracking);
    window.MC.Vendors.PubSub.subscribe("tracking.mc", (e, data) =>
      sendTrackingToParent(e, data, "mc")
    );
    window.MC.Vendors.PubSub.subscribe("tracking.mc", GATracking);
  }
};

export { listenTracking, getClientId };
